import { render } from "./RestLoader.vue?vue&type=template&id=4a82b82a"
import script from "./RestLoader.vue?vue&type=script&lang=js"
export * from "./RestLoader.vue?vue&type=script&lang=js"

import "./RestLoader.vue?vue&type=style&index=0&id=4a82b82a&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__